import { ArcFocusablesHelper as Helper } from './ArcFocusablesHelper.js';
export const ArcFocusablesHelper = new Helper();
